/* The Card Cabin — global theme JS */
(function () {
  'use strict';

  /* Scroll-Reveal */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { obs.observe(e); });
  }

  /* Mengen-Stepper */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (box) {
      var input = box.querySelector('input');
      box.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v = btn.dataset.step === 'down' ? Math.max(1, v - 1) : Math.min(99, v + 1);
          input.value = v;
        });
      });
    });
  }

  /* Varianten-Auswahl: Preis aktualisieren */
  function initVariants() {
    document.querySelectorAll('[data-variant-select]').forEach(function (sel) {
      var form = sel.closest('form');
      var priceEl = form ? form.querySelector('[data-price]') : null;
      function update() {
        var opt = sel.options[sel.selectedIndex];
        if (priceEl && opt && opt.dataset.price) {
          var html = opt.dataset.price;
          if (opt.dataset.compare && opt.dataset.compare !== opt.dataset.price) {
            html += ' <s>' + opt.dataset.compare + '</s>';
          }
          priceEl.innerHTML = html;
        }
      }
      sel.addEventListener('change', update);
    });
  }

  /* Galerie-Thumbnails */
  function initGallery() {
    var main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    document.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.dataset.full || t.querySelector('img').src;
        document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initQty();
    initVariants();
    initGallery();
  });
})();
